import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Numeral } from '@atlassian/amkt-common';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class Stats extends Component {
  getFormattedNumberOfHits() {
    const {
      numberOfHits
    } = this.props;
    if (numberOfHits <= 1000) {
      return Numeral.longFormat(numberOfHits);
    }
    return 'Over 1,000';
  }
  render() {
    return /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx("span", {
        children: this.getFormattedNumberOfHits()
      }), /*#__PURE__*/_jsx("span", {
        children: " results"
      })]
    });
  }
}
_defineProperty(Stats, "propTypes", {
  numberOfHits: PropTypes.number.isRequired
});